import React, { useState, useEffect, useMemo } from 'react';
import './GroupParam.css';
import Man3 from '../media/imagen/3man.svg';
import PlusMan from '../media/imagen/PlusMan.svg';
import HandMan from '../media/imagen/HandMan.svg'

const GroupParam = ({ testID }) => {
    const [testDataGroup, setTestDataGroup] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expanTextS, setExpanTextS] = useState("");
    const [splochTextS, setSplochTextS] = useState("");

    useEffect(() => {
        const fetchMatrixData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/Group?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);

                const result = await response.json();
                setTestDataGroup(result.results);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchMatrixData();
    }, [testID]);

    const expanText = useMemo(() => {
        if (!testDataGroup) return ""; 
        
        const val = testDataGroup.expansive;
        
        if (val == 0) return "Участники группы вообще не делают выборов (пассивность)";
        if (val < 1 && val > 0) return "Очень низкий уровень активности в группе";
        if (val == 1) return "Средний уровень активности (каждый участник делает в среднем один выбор)";
        if (val > 1 && val < 2) return "Высокая активность, участники делают больше одного выбора в среднем";
        if (val >= 2) return "Очень высокая активность, группа демонстрирует насыщенное взаимодействие";
        
        return "Непредвиденное значение";
    }, [testDataGroup]); 

    const splochText = useMemo(() => {
        if (!testDataGroup) return "";
        const val = testDataGroup.sploch;
        
        if (val === 0) return "Полное отсутствие взаимодействий в группе";
        if (val > 0 && val <= 0.25) return "Низкая степень взаимодействия внутри группы";
        if (val > 0.25 && val <= 0.5) return "Умеренная активность взаимодействий";
        if (val > 0.5 && val <= 0.75) return "Высокая активность, члены группы активно взаимодействуют";
        if (val > 0.75 && val <= 1) return "Очень высокая сплочённость и эмоциональная активность";
        
        return "Некорректное значение сплоченности";
    }, [testDataGroup]);

    useEffect(() => {
        setExpanTextS(expanText);
    }, [expanText]);

    useEffect(() => {
        setSplochTextS(splochText);
    }, [splochText]);

    if (loading) return <div className="loading">Загрузка данных...</div>;
    if (error) return <div className="error">Ошибка: {error}</div>;
    if (!testDataGroup) return <div className="no-data">Нет данных для отображения</div>;

    return (
        <div className="GroupParam-container">
            <div className='GroupParam-card relative'> {/* Добавлен класс relative */}
                <img 
                    src={Man3} 
                    alt="Экспансивность" 
                    className="group-icon" // Новый класс для стилизации
                /> 
                <h2>Экспансивность группы</h2>
                <span className='BigNum'>{testDataGroup.expansive.toFixed([2])}</span>
                <br></br>
                <span className='GroupParam-des'>{expanTextS}</span>
                <div className='help-param'>
                    __________
                    <br></br>
                    <br></br>
                <span className='GroupParam-help'>Экспансивность группы — этот индекс характеризует, какая часть группы является значимой при данном критерии и отражает отношение членов коллектива друг к другу.</span>
                </div>
            </div>
            
            <div className='GroupParam-card relative'> {/* Добавлен класс relative */}
                <img 
                    src={PlusMan} 
                    alt="Экспансивность" 
                    className="group-icon" // Новый класс для стилизации
                /> 
                <h2>Интеграция группы</h2>
                <span className='BigNum'>{testDataGroup.integration.toFixed([2])}</span>
                <div className='help-param'>
                    __________
                    <br></br>
                    <br></br>
                <span className='GroupParam-help'>Интеграция группы — это способность груп­пы интегрировать членов группы в единое целое.</span>
                </div>
            </div>

            <div className='GroupParam-card relative'> {/* Добавлен класс relative */}
                <img 
                    src={HandMan} 
                    alt="Экспансивность" 
                    className="group-icon" // Новый класс для стилизации
                /> 
                <h2>Сплоченность группы</h2>
                <span className='BigNum'>{testDataGroup.sploch.toFixed([2])}</span>
                <span className='GroupParam-des'>{splochTextS}</span>
                <div className='help-param'>
                    __________
                    <br></br>
                    <br></br>
                <span className='GroupParam-help'>Сплоченность группы — это уровень взаимосвя­занности членов группы, тесноту их эмоциональных связей, стремление членов коллектива или группы к взаимному сотрудничеству.</span>
                </div>
            </div>
        </div>
    );
};

export default GroupParam;